import React, { useMemo } from 'react';

import { Avatar, AvatarProps } from '@mui/material';

interface Props extends Omit<AvatarProps, 'children'> {
    name: string;
}

const LetterAvatar: React.FC<Props> = ({ name, ...props }) => {
    const bgcolor = useMemo(() => {
        const hash = name.split('').reduce((acc, item) => item.charCodeAt(0) + ((acc << 5) - acc), 0);

        return Array.from({ length: 3 })
            .map((_, i) => i)
            .reduce((acc, item) => acc + `00${((hash >> (item * 8)) & 0xff).toString(16)}`.slice(-2), '#');
    }, [name]);

    const initials = useMemo(
        () =>
            name
                .split(' ')
                .map((name) => name[0])
                .join('')
                .toUpperCase(),
        [name]
    );

    return (
        <Avatar {...props} sx={{ ...props.sx, bgcolor }}>
            {initials}
        </Avatar>
    );
};

export default LetterAvatar;
